import { geodesistCallsAPI } from "./api";

export const getGeodesistCalls = async (params) => {
  try {
    const res = await geodesistCallsAPI.getGeodesistCalls(params);
    // API может вернуть данные напрямую или в res.data
    return res?.data || res || [];
  } catch (e) {
    console.error("Error loading geodesist calls:", e);
    return [];
  }
};

export const addGeodesistDoc = async (file, help_call_id) => {
  try {
    const formData = new FormData();
    formData.append("doc", file);
    formData.append("help_call_id", help_call_id);
    
    const res = await geodesistCallsAPI.addGeodesistDoc(formData);
    return res;
  } catch (e) {
    console.error("Error adding geodesist doc:", e);
    throw e;
  }
};
